// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_mEUfj","footer2":"index_footer2_BPb8h"};